var React = require('react');

function RemoveFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.667 31.653l-3.014 3.014L24 27.013l-7.653 7.654-3.014-3.014L20.987 24l-7.654-7.653 3.014-3.014L24 20.987l7.653-7.654 3.014 3.014L27.013 24l7.654 7.653zM24 2.667C12.213 2.667 2.667 12.213 2.667 24c0 11.787 9.546 21.333 21.333 21.333 11.787 0 21.333-9.546 21.333-21.333 0-11.787-9.546-21.333-21.333-21.333z"}));
}

RemoveFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = RemoveFilled;

RemoveFilled.default = RemoveFilled;
